import type EnType from '../en-US/commonParameter';

export default {
  'commonParameter.title.addParameter': 'Agregar Parámetros',
  'commonParameter.title.name': 'Nombre',
  'commonParameter.title.nameNotNull.message': '¡El nombre no puede estar vacío!',
  'commonParameter.placeHolder.chooseType': 'Elegir Tipo',
} satisfies typeof EnType;
